import { MarketModalFull } from "@market/react";
import { withMarketDialog } from "/src/components/ui/modals/with-market-dialog";

export const BankingMarketModalFull = withMarketDialog(MarketModalFull);
